import { createSlice } from "@reduxjs/toolkit";
import { getViewAllAuditTrail } from "../../api/postCall/viewAllAuditTrail";
import { ViewAllEvents } from "../../data-model/viewAllEvents";

export interface ViewAllAuditTrailState {
  data?: ViewAllEvents;
  isLoading: boolean;
  error?: string;
}

const initialState: ViewAllAuditTrailState = {
  data: undefined,
  isLoading: false,
  error: undefined,
};

const viewAllAuditTrailSlice = createSlice({
  name: "viewAllAuditTrail",
  initialState,
  reducers: {
    setViewAllAuditTrail: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = undefined;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.error = undefined;
      state.data = undefined;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.data = undefined;
    },
    resetViewAllAuditTrail: (state) => {
      state.data = undefined;
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  setViewAllAuditTrail,
  setIsLoading,
  setError,
  resetViewAllAuditTrail,
} = viewAllAuditTrailSlice.actions;

export const fetchViewAllAuditTrail =
  (orderId: string) => async (dispatch, getState) => {
    const state = getState();
    if (state.viewAllAuditTrail.isLoading) return;

    dispatch(setIsLoading());
    try {
      const response = await getViewAllAuditTrail({ order_id: orderId });
      dispatch(setViewAllAuditTrail(response));
    } catch (error) {
      dispatch(setError(error as string));
    }
  };
export default viewAllAuditTrailSlice.reducer;
